import React from 'react';
import '../../../styles/helpmerealestatefaq.scss';

export default function Helpmefaq(props) {
	return (
		<div>
			<div className="pl-3">
				{props?.partner?.url_path === 'c2'?"C2 Buy Before You Sell":"The Trade-In Mortgage™"} positions real estate agents like you to succeed in a number of ways:
			</div>
			<br />
			<div className="how-content-helpmefaq">
				<ul className="pl-3">
					<li>
						You and your clients will submit non-contingent offers that function like all-cash offers on their new home prospects, meaning <b>you’ll close more deals</b>.
					</li>
				</ul>
			</div>
			<div className="how-content-helpmefaq">
				<ul className="pl-3">
					<li>
						You will be able to offer clients an easier, simpler home buying experience compared to your competitors, <b>winning you more clients</b>.
					</li>
				</ul>
			</div>
			<div className="how-content-helpmefaq">
				<ul className="pl-3">
					<li>
						You will be able to list and show an empty home that has been repaired and staged to make sure it looks great, ensuring you and your clients <b>get the best sales price. </b>
					</li>
				</ul>
			</div>
			<div className="how-content-helpmefaq">
				<ul className="pl-3">
					<li>
						You can give your clients a better experience at <b>no cost to you</b>. You won’t pay any fees or sacrifice any commissions.										</li>
				</ul>
			</div>
			<div className="how-content-helpmefaq">
				<ul className="pl-3">
					<li>
						{props?.partner?.url_path === 'c2'?"C2 Buy Before You Sell":"The Trade-In Mortgage™"} almost guarantees you will be <b>involved on both the sell side and buy side</b>.
					</li>
				</ul>
			</div>
		</div>
	)
}